import {Injectable, EventEmitter} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/Rx'

// Classes
import {ProductCategory} from '../classes/product-category';
import {Product} from '../classes/product';

// Config
import {CONFIG} from '../../../../config/config';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductCategoriesService'));

@Injectable()
export class ProductCategoriesService {

    private _categories = [];
    private _rootCategory = null;
    private _catalogService;
    private _imgPaths;

    
    constructor (
        private _http: Http
    ) {
        // 'Construct product categories service' );
    }

    
    public init (catalogService) {
        // 'Initialise products categories service' );
        this._catalogService = catalogService;
        this._imgPaths = this._catalogService.imgPaths;
    }

    /** TODO: Secure api
     * REST service method
     */
    public getAllCategoriesAsync (): Observable<ProductCategory[]> {
        // 'Get all categories async' );

        let self = this,
            domain = CONFIG.domain,
            observable = this._http.get( domain + 'api/category' )
                .map( res => res.json() )
                .catch( this._handleError );

        // Cache values in service
        observable.subscribe(
            response => {
                self._categories = response;
                debugOff( 'Categories:', self._categories );
            },
            error => console.error( error )
        );

        return observable;
    }

    /** TODO: Secure api
     * REST service method
     */
    public getCategoryByIdAsync (id): Observable<ProductCategory> {
        // 'Get products category by id async' );

        let domain = CONFIG.domain;

        return this._http.get( domain + 'api/category/' + id )
            .map( res => res.json() )
            .catch( this._handleError );
    }

    /** TODO: Secure api
     * REST service method
     */
    public saveCategoryAsync (category) {
        // 'Save products category async' );

        let domain = CONFIG.domain;

        if (category.id === 0) {

            // Create new product category
            return this._http.post( domain + 'api/category', category )
                .map( res => res.json() )
                .catch( this._handleError );
        } else {

            // Update existing category
            return this._http.put( domain + 'api/category/' + category.id, category )
                .map( res => res.json() )
                .catch( this._handleError );
        }
    }

    /** TODO: Secure api
     * REST service method
     */
    public deleteCategoryAsync (category) {
        // 'Delete products category async' );

        let domain = CONFIG.domain;

        return this._http.delete( 'api/category/' + category.id )
            .map( res => category )
            .catch( this._handleError );
    }

    
    public getProductCategoriesList () {
        // 'Get product categories list' );
        debugOff( 'Product categories list:', this._categories );
        return this._categories;
    }

    
    public getRootCategory () {
        // 'Get root category' );
        debugOff( 'Root category:', this._rootCategory );
        return this._rootCategory;
    }

    /** Get full path
     */
    public getCategoryThumbnailPath ( category: ProductCategory) {
        if (category === undefined) { console.error( 'Cannot return category thumbnail path, category is undefined' ); return; }

        debugOff( 'Get "' + category.id + '" category thumbnail' );

        let path;

        if (category.image !== null) {

            // Use own image
            path = this._imgPaths.categories + category.image;
        } else {

            let productThumb = this.getFeaturedProductThumb( category );

            if (productThumb !== null) {

                // Use featured product
                path = this._imgPaths.products + this.getFeaturedProductThumb( category );
            } else {

                // Use placeholder image
                path = this._imgPaths.categories + 'Category-Placeholder.jpg';
            }
        }

        debugOff( 'Category thumbnail path:', path );

        return path;
    }

    
    public getFeaturedProductThumb (category: ProductCategory) {
        debugOff( 'Get featured product thumbnail for "' + category.id + '" category' );

        function retrieveThumb (category) {
            if (category.products[0] !== undefined) {

                // Return first product thumb if found
                return category.products[0].images.folder + category.products[0].images.thumbnail;
            } else if (category.subcategories !== undefined &&
                category.subcategories.length !== 0
            ){

                // Iterate trough subcategories until a product is found
                for (let subCatId = 0; subCatId < category.subcategories.length; subCatId++) {
                    let subCategory = category.subcategories[subCatId];
                    return retrieveThumb (subCategory);
                }
            } else {
                return null;
            }
        }

        // Start recursive call
        return retrieveThumb( category );
    }

    
    public getProductCategoryById (id) {
        debugOff( 'Get product category by "' + id + '" ID' );
        let category = this._categories.find( category => {return category.id === id;});
        category === undefined && console.warn(`Category ${id} is undefined`);
        debugOff( 'Category:', category );
        return category;
    }

    /** Can handle unsorted categories
     * Categories with `parentCategoryId === null` are considered children of `rootCategory`
     * Can be improved to handle streaming categories data
     * Vulnerable to circular references
     */
    public generateCategoriesThree () {
        // 'Generate categories three' );

        // Create root category object
        let rootCategory: ProductCategory = {
            _uuid: null,
            _id: 'rootCategory',
            id: 'rootCategory',
            parentCategoryId: null,
            menuName: null,
            title: null,
            subtitle: null,
            shortDescription: null,
            techSpecsLink: null,
            image: null,
            renderMode: 'expanded',
            customRenderer: null,
            isVisible: true,
            // cart: {
            //     limitOneProduct: 'allSubCategs' // 'self', 'eachSubCateg',
            // },
            allowInCartMultipleProds: true,
            sortOrder: 0,
            zIndex: 0,
            products: [],
            subcategories: []
        };

        // Create child categories temporary cache
        let childCategs = {};

        this._categories.forEach( category => {

            // Check category.parentCategoryId is defined
            let parentCatId = category.parentCategoryId;
            if (parentCatId === undefined) { console.error( '"category.parentCategoryId" is undefined' ); return; }

            // Add categories with no parent id to root category
            if (parentCatId === null) { rootCategory.subcategories.push( category ); return; }

            // Create children categories array
            childCategs[parentCatId] === undefined && (childCategs[parentCatId] = []);

            // Cache child category
            childCategs[parentCatId].push( category );
        });

        debugOff( 'Children categories arrays:', childCategs );

        // Attach children categories to parent categories
        for (let parentCatId in childCategs) {
            let category =  this.getProductCategoryById( parentCatId );
            !category && console.warn( 'Cannot add subcategories. "' + parentCatId + '" parent category is undefined.' );
            category.subcategories = childCategs[parentCatId];
        }

        // Cache `rootCategory`
        this._categories.push( rootCategory );
        this._rootCategory = rootCategory;
        debugOff( 'Root category:', rootCategory );

        return rootCategory;
    }

    
    public updateCategoriesSortOrder () {

        let self = this;

        // 'Sort all categories' );

        this._categories.forEach( (category: ProductCategory) => {

            // Prevent traversing empty categories
            if (category.subcategories === undefined ||
                category.subcategories.length === 0
            ) {
                return;
            }

            // 'Sort subcategories of "' + category.id + '"' );

            // Set sort default value if missing
            category.subcategories.forEach( (subcategory: ProductCategory) =>{
                subcategory.sortOrder === undefined && ( category.sortOrder = 0 );
            });

            // Sort subcategories
            category.subcategories.sort( (a, b) => { return a.sortOrder - b.sortOrder; });
            debugOff( 'Sorted subcategories of "' + category.id + '":', category.subcategories );

        });

    }

    /** Shallow clone is used to maintain references to other objects.
     */
    public shallowCloneCategory (category: ProductCategory) {
        debugOff( 'Clone subcategories' );
        debugOff( '"' + category.id + '" category:', category );

        let cloneCategory = {};

        // Shallow clone
        for (let prop in category) {
            cloneCategory[prop] = category[prop];
        }

        return cloneCategory;
    }

    /** Shallow clone is used to maintain references to other objects.
     */
    public shallowCloneSubcategories (category: ProductCategory) {
        debugOff( 'Clone subcategories' );
        debugOff( '"' + category.id + '" category:', category );
        debugOff( 'Subcategories:', category.subcategories );

        let subcategories = [];

        // Shallow clone
        category.subcategories && category.subcategories.forEach( subcategory => {
            subcategories.push( subcategory );
        });

        return subcategories;
    }

    
    public getAllProducts (category: ProductCategory) {
        debugOff( 'Get all products in category and all subcategories' );
        debugOff( '"' + category.id + '" category:', category );

        let products = [];

        // Get all products
        getProducts( category );

        function getProducts( _category: ProductCategory ) {

            // Cache products
            _category.products !== undefined && ( products = products.concat( _category.products ) );

            // Run recursively
            _category.subcategories && _category.subcategories.forEach( subcategory => {
                getProducts( subcategory );
            });
        }

        debugOff( 'Products:', products );

        return products;
    }

    
    public appendProductAPI (products: Array<Product>) {
        // 'Append product API' );

        let self = this;

        products.forEach( (product: Product) => {

            
            product.getCurrentCategory = () => {

                debugOff( 'Get "' + product.code + '" product current parent category' );

                return self.getProductCategoryById( product.taxonomy.currentCategoryId );
            };
        });
    }

    
    private _handleError (error: Response) {
        console.error( error );
        return Observable.throw( error.json().error || 'Server error' );
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/services/product-categories-service.ts